import { render, staticRenderFns } from "./ReceivableInvestorNoteIcon.vue?vue&type=template&id=576c6c6d&scoped=true&"
import script from "./ReceivableInvestorNoteIcon.vue?vue&type=script&lang=js&"
export * from "./ReceivableInvestorNoteIcon.vue?vue&type=script&lang=js&"
import style0 from "./ReceivableInvestorNoteIcon.vue?vue&type=style&index=0&id=576c6c6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576c6c6d",
  null
  
)

export default component.exports